module.exports = __webpack_public_path__ + "svg/new-visa-big.7adf6f715d8dc0158412e1c72921b1ab.svg";